<template>
    <div class="drawer-page">
        <div class="data-list">
            <p v-if="dataList.length<=0||data.length<=0" class="tac ">请先选择项目</p>
            <template v-else>
                <div class="data-list-title">
                    <span class="title">项目详情</span>
                    <span 
                        v-if="hasErr.length>0"
                        class="tip el-icon-warning-outline text-color-error" 
                        style="text-decoration: underline;"
                        :data-id="`#form_${errData[0].project_id}`"
                        @click="()=>scrollToError('form_'+errData[0].project_id)"
                    >
                        【{{ hasErr.length }}】个项目缺少必填项，请补充，可点击此处快速编辑
                    </span>
                </div>
                <el-collapse v-model="collapseActiveNames" >
                    <el-collapse-item 
                        v-for="item in dataList" 
                        :key="item.project_id" 
                        :title="item.project_name" 
                        :name="item.project_id"
                    >
                        <template slot="title">
                            <div class="flex items-center">
                                <span class="flex-1" :id="`form_${item.project_id}`">{{item.project_name}}</span>
                                <span class="text-color-error font12px pl10 el-icon-warning-outline" v-if="hasErr.includes(item.project_id)">待完善</span>
                                <span class="text-color-success font12px el-icon-check pl10" v-else>已完善</span>
                            </div>
                        </template>
                        <!-- <p class="text-color-gray font12px mt6 pl6">
                            <span v-if="item.type=='1'">该项目无匹配产品信息需要手动填写</span>
                            <span v-else-if="item.type=='2'">该项目有多个产品信息，请选择一个正确的产品信息</span>
                            <span v-else-if="item.type=='3'">该项目无匹配产品信息需要手动填写</span>
                            <span v-else-if="item.type=='4'">该项目无匹配产品信息需要手动填写</span>
                        </p> -->
                        <div class="detail mb10">
                            <el-form :ref="'form'+item.project_id" label-width="100px" size="mini">
                                <el-form-item label="产品：" class="product-form-item">
                                    <product-select :project-id="item.project_id" :value="item.products || []"
                                                    :disabled="isEdit && item.has_material" @input="$set(item, 'products', $event)" />
                                </el-form-item>
                                <!-- -1：正常 -->
                                <template v-if="item.type==-1">
                                    <el-form-item label="产品类型：" class="label-required">
                                        <span class="font12px">{{item.app_type=='1'?'应用':'游戏'}}</span>
                                    </el-form-item>
                                    <el-form-item label="包体类型：" class="label-required">
                                        <el-radio-group v-model="item.package_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.package_type_disable">
                                            <el-radio label="11">安卓应用</el-radio>
                                            <el-radio label="12">安卓快应用</el-radio>
                                            <el-radio label="3">小程序</el-radio>
                                            <el-radio label="21">iOS应用</el-radio>
                                            <el-radio label="41">鸿蒙应用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="item.app_type=='2'" label="游戏分类：" class="label-required">
                                        <span class="font12px" v-if="item.game_classify=='3'">IAA</span>
                                        <span class="font12px" v-else-if="item.game_classify=='4'">IAP</span>
                                        <span v-else>-</span>
                                    </el-form-item>
                                </template>

                                <!-- 1：需要填写项目日预算 -->
                                <template v-if="item.type==1">
                                    <el-form-item label="产品类型：" class="label-required">
                                        <span class="font12px"> {{item.app_type=='1'?'应用':'游戏'}}</span>
                                    </el-form-item>
                                    <el-form-item label="包体类型：" class="label-required">
                                        <el-radio-group v-model="item.package_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.package_type_disable">
                                            <el-radio label="11">安卓应用</el-radio>
                                            <el-radio label="12">安卓快应用</el-radio>
                                            <el-radio label="3">小程序</el-radio>
                                            <el-radio label="21">iOS应用</el-radio>
                                            <el-radio label="41">鸿蒙应用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="item.app_type=='2'" label="游戏分类：" class="label-required">
                                        <span class="font12px" v-if="item.game_classify=='3'">IAA</span>
                                        <span class="font12px" v-else-if="item.game_classify=='4'">IAP</span>
                                        <span v-else>-</span>
                                    </el-form-item>
                                    <el-form-item label="项目日预算：" prop="avg_daily_cost" class="label-required">
                                        <el-input-number :min="0" :max="100" :precision="2" v-model="item.avg_daily_cost"  :controls="false" placeholder="以万为单位，不能大于100万"  style="width:200px;"></el-input-number>
                                        <span class="ml4 font12px">万元</span>
                                    </el-form-item>
                                </template>

                                <!-- 2：多个产品，需要先选择产品类型和游戏分类 -->
                                <template v-if="item.type==2">
                                    <el-form-item label="产品类型：" prop="app_type" class="label-required">
                                        <el-radio-group v-model="item.app_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.app_type_disable">
                                            <el-radio label="1">应用</el-radio>
                                            <el-radio label="2">游戏</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="包体类型：" class="label-required">
                                        <el-radio-group v-model="item.package_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.package_type_disable">
                                            <el-radio label="11">安卓应用</el-radio>
                                            <el-radio label="12">安卓快应用</el-radio>
                                            <el-radio label="3">小程序</el-radio>
                                            <el-radio label="21">iOS应用</el-radio>
                                            <el-radio label="41">鸿蒙应用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="item.app_type=='2'" label="游戏分类：" prop="game_classify" class="label-required">
                                        <el-radio-group v-model="item.game_classify" :disabled="item.game_classify_disable" @change="(val)=>getProjectCost(val,item,true)">
                                            <el-radio label="3">IAA</el-radio>
                                            <el-radio label="4">IAP</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="项目日预算：" v-if="item.need_cost" prop="avg_daily_cost" class="label-required">
                                        <el-input-number :min="0" :max="100" :precision="2" v-model="item.avg_daily_cost" :controls="false"  placeholder="以万为单位，不大于100万" style="width:200px;"></el-input-number>
                                        <span class="ml4 font12px">万元</span>
                                    </el-form-item>
                                </template>

                                <!-- 3：产品类型，游戏分类，项目日预算均需要填写 -->
                                <template v-if="item.type==3">
                                    <el-form-item label="产品类型：" prop="app_type" class="label-required">
                                        <el-radio-group v-model="item.app_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.app_type_disable">
                                            <el-radio label="1">应用</el-radio>
                                            <el-radio label="2">游戏</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="包体类型：" class="label-required">
                                        <el-radio-group v-model="item.package_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.package_type_disable">
                                            <el-radio label="11">安卓应用</el-radio>
                                            <el-radio label="12">安卓快应用</el-radio>
                                            <el-radio label="3">小程序</el-radio>
                                            <el-radio label="21">iOS应用</el-radio>
                                            <el-radio label="41">鸿蒙应用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="item.app_type=='2'" label="游戏分类：" prop="game_classify" class="label-required">
                                        <el-radio-group v-model="item.game_classify" @change="(val)=>getProjectCost(val,item,true)">
                                            <el-radio label="3">IAA</el-radio>
                                            <el-radio label="4">IAP</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="项目日预算：" prop="avg_daily_cost" class="label-required">
                                        <el-input-number :min="0" :max="100" :precision="2" v-model="item.avg_daily_cost" :controls="false"  placeholder="以万为单位，不大于100万" style="width:200px;"></el-input-number>
                                        <span class="ml4 font12px">万元</span>
                                    </el-form-item>
                                </template>

                                <!-- 4：无产品类型，游戏分类，但有项目日预算 -->
                                <template v-if="item.type==4">
                                    <el-form-item label="产品类型：" prop="app_type" class="label-required">
                                        <el-radio-group v-model="item.app_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.app_type_disable">
                                            <el-radio label="1">应用</el-radio>
                                            <el-radio label="2">游戏</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="包体类型：" class="label-required">
                                        <el-radio-group v-model="item.package_type" @change="(val)=>getProjectCost(val,item,true)" :disabled="item.package_type_disable">
                                            <el-radio label="11">安卓应用</el-radio>
                                            <el-radio label="12">安卓快应用</el-radio>
                                            <el-radio label="3">小程序</el-radio>
                                            <el-radio label="21">iOS应用</el-radio>
                                            <el-radio label="41">鸿蒙应用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="item.app_type=='2'" label="游戏分类：" prop="game_classify" class="label-required">
                                        <el-radio-group v-model="item.game_classify" @change="(val)=>getProjectCost(val,item,true)">
                                            <el-radio label="3">IAA</el-radio>
                                            <el-radio label="4">IAP</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </template>
                                <el-form-item label="游戏类型：">
                                    <el-select v-model="item.project_tag11" placeholder="请选择">
                                        <el-option 
                                            v-for="item in (defaultOptions.project_tag11 || [])"
                                            :key="item.id"
                                            :label="item.name" :value="item.id"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="游戏题材：">
                                    <el-select v-model="item.project_tag12" placeholder="请选择">
                                        <el-option 
                                            v-for="item in (defaultOptions.project_tag12 || [])"
                                            :key="item.id"
                                            :label="item.name" :value="item.id"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="item.is_new || isEdit" label="是否新品：" prop="is_new" class="label-required">
                                    <el-radio-group  v-model="item.is_new" >
                                        <el-radio label='1'>是</el-radio>
                                        <el-radio label='2'>否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item   class="label-required">
                                    <template slot="label">
                                        <span>客户名称：</span>
                                        <el-tooltip  placement="top-end">
                                            <template slot="content">
                                                <div>
                                                    <p>按照以下规则自动获取名称，如有误可手动修改，多个时使用中文分号分隔“；”</p>
                                                    <p> 取近30天创建人权限内有消耗的客户名称，无消耗时取客户产品管理中绑定且启用的客户名称</p>
                                                </div>
                                            </template>
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </template>
                                    <el-input v-model="item.company_name" placeholder="请输入客户名称" clearable/>
                                </el-form-item>
                                <el-form-item label="集团名称：" class="label-required">
                                    <template slot="label">
                                        <span>集团名称：</span>
                                        <el-tooltip  placement="top-end">
                                            <template slot="content">
                                                <div>
                                                    <p>按照以下规则自动获取名称，如有误可手动修改，多个时使用中文分号分隔“；”</p>
                                                    <p> 取近30天创建人权限内有消耗的集团名称，无消耗时取客户产品管理中绑定且启用的集团名称</p>
                                                </div>
                                            </template>
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </template>
                                    <el-input v-model="item.bloc_name" placeholder="请输入集团名称" clearable/>
                                </el-form-item>
                                
                            </el-form>
                            <p v-if="errTips[item.project_id]" class="text-color-error font12px mt20">{{errTips[item.project_id]}}</p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </template>
        </div>
    </div>
</template>

<script>
    import { cloneDeep, keyBy } from 'lodash';
    import API from '@/api/workOrder/create.js';
    import ProductSelect from './productSelect.vue';
    export default {
        name: "ProjectInfoDrawer",
        components: { ProductSelect },
        props:{
            data:Array,
            isEdit:Boolean,
            isCopy:Boolean,
            cbs:{
                type:Object,
            },
        },
        data(){
            return {
                submitLoading:false,
                dataLoading:false,
                appTypeList:[
                    {id:'1',name:'应用',},
                    {id:'2',name:'游戏',},
                ],
                dataList:[],
                isChangeFormValue:false,
                errTips:{},
                collapseActiveNames:[],
                defaultOptions: {},
            }
        },
        computed:{
            errData(){
                let errList = [];
                this.dataList.forEach(item=>{
                    if(!(item.bloc_name && item.company_name) || !item.is_new) {
                        errList.push(item);
                        return;
                    }
                    if(item.type=='1'&&!item.avg_daily_cost){
                        errList.push(item);
                    }else if(item.type=='2'){
                        if(!item.app_type){
                            errList.push(item);
                        }else if(item.app_type=='2'&&!item.game_classify){
                            errList.push(item);
                        }else if(item.need_cost&&!item.avg_daily_cost){
                            errList.push(item);
                        }
                    }else if(item.type=='3'){
                        if(!item.app_type){
                            errList.push(item);
                        }else if(item.app_type=='2'&&!item.game_classify){
                            errList.push(item);
                        }else if(!item.avg_daily_cost){
                            errList.push(item);
                        }
                    }else if(item.type=='4'){
                        if(!item.app_type){
                            errList.push(item);
                        }else if(item.app_type=='2'&&!item.game_classify){
                            errList.push(item);
                        }
                    }
                   
                });
                return errList ;
            },
            needSubmitData(){
                return this.dataList.some(item=>item.type!=-1);
            },
            hasErr(){
                const data = keyBy(this.errData,'project_id');
                return Object.keys(data);
            }
        },
        mounted(){
           API.getProjectTag().then(res => {
                // this.$message.success('成功')
                this.defaultOptions = res.data
            }, err => {
                this.$message.error(err.info)
            })
        },
        methods:{
            scrollToError(id){
                let element = document.getElementById(id);
                if(element){
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            },
            resetData(){
                const idData = keyBy(this.dataList,'project_id');
                this.dataList = cloneDeep(this.data.map(item=> {
                    let data = idData[item.project_id];
                    if (data) {
                        return data;
                    }else{
                        return item;
                    }
                }));
                this.collapseActiveNames = [];
                this.dataList.forEach(item=>{
                    this.collapseActiveNames.push(item.project_id);
                    console.log(11111111111111);
                    if(!item.avg_daily_cost){
                        item.avg_daily_cost = undefined;
                    }
                    /* BUG #12789:复制工单后发现没有显示日预算的框 */
                    if(this.isCopy){
                        if(item.type=='2'){
                            this.getProjectCost('',item,false);
                        }
                    }else{
                        if(item.type=='2'&&item.app_type&&item.avg_daily_cost){
                            // this.$set(item,'need_cost',true)
                        }
                    }
                })
            },
            submitData(){
                this.errTips = {};
                this.dataList.forEach(item=>{
                    if(item.type!='-1'){
                        if(!item.app_type){
                            let oldStr = this.errTips[item.project_id]||'';
                            this.$set(this.errTips,item.project_id,oldStr+'请选择产品类型；');
                        }
                        if(!item.package_type){
                            let oldStr = this.errTips[item.project_id]||'';
                            this.$set(this.errTips,item.project_id,oldStr+'请选择包体类型；');
                        }
                        if(item.app_type=='2'&&!item.game_classify){
                            let oldStr = this.errTips[item.project_id]||'';
                            this.$set(this.errTips,item.project_id,oldStr+'请选择游戏类型；');
                        }
                        if(item.need_cost||item.type=='1'||item.type=='3'){
                            if(!item.avg_daily_cost&&item.avg_daily_cost!==0){
                                let oldStr = this.errTips[item.project_id]||'';
                                this.$set(this.errTips,item.project_id,oldStr+'请填写项目日预算；');
                            }else{
                                if(item.avg_daily_cost<=0){
                                    let oldStr = this.errTips[item.project_id]||'';
                                    this.$set(this.errTips,item.project_id,oldStr+'项目日预算需大于0，最大支持100；');
                                }else if(item.avg_daily_cost>100){
                                    let oldStr = this.errTips[item.project_id]||'';
                                    this.$set(this.errTips,item.project_id,oldStr+'项目日预算最大支持100；');
                                }else if(!/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(item.avg_daily_cost)){
                                    let oldStr = this.errTips[item.project_id]||'';
                                    this.$set(this.errTips,item.project_id,oldStr+'项目日预算最多支持2为小数；');
                                }
                            }
                        }
                    }
                });

                if(this.errList.length>0||Object.values(this.errTips).length>0){
                    return this.$message.error('当前项目信息不全')
                }
                this.cbs.onSubmit(this.dataList.map(item=>{
                    item.game_classify =  item.app_type=='1'&&!item.game_classify_disable?null:item.game_classify;
                    return item;
                }));
            },
            getProjectCost(val,item,isDeep){
                this.isChangeFormValue = true;
                // 切换成应用，清空game_classify的值
                if(val=='1' && !item.game_classify_disable){
                    item.game_classify = '';
                }
                if(item.app_type=='2'&&!item.game_classify) return;
                if(!item.package_type||!item.app_type) return;
                this.dataLoading = true;
                API.getProjectDetailCost({
                    package_type:item.package_type,
                    project_id: item.project_id,
                    app_type: item.app_type,
                    game_classify: val=='1' ? '' : item.game_classify,
                }).then(res=>{
                    console.log('getProjectDetailCost',res);
                     this.dataLoading = false;
                    let resData = res.data||{};
                    this.$set(item,'need_cost',!resData.avg_daily_cost);
                    console.log(item.is_new, resData.avg_daily_cost);
                    if(!item.is_new){
                        this.$set(item,'is_new', resData.avg_daily_cost ? '2' : '1' );
                    }
                    if(isDeep){
                        this.$set(item,'avg_daily_cost',resData.avg_daily_cost||undefined);
                    }else{
                        this.$set(item,'avg_daily_cost',item.avg_daily_cost||resData.avg_daily_cost||undefined);
                    }
                },err=>{
                    console.log('getProjectDetailCost err',err);
                     this.dataLoading = false;
                    this.$message.error(err.info||'请求异常');
                })
                if(isDeep){
                    this.clearProjectErrTip(item);
                }
            },
            changeAvgDailyCost(val,item){
                this.isChangeFormValue = true;
                this.clearProjectErrTip(item);
            },
            clearProjectErrTip(item){
                this.$set(this.errTips,item.project_id,'');
            },
        },
        watch: {
            errData: {
                handler(newVal,oldVal){
                    this.$parent.updateProjectList(this.dataList);
                },
            }
        },
    }
</script>

<style lang="scss" scoped>
    .drawer-page{
        .data-list{
            ::v-deep .product-form-item { margin-top: 10px; }
            ::v-deep .el-form-item{
                margin-bottom: 6px;
            }

            ::v-deep .box-card .el-card__body{
                padding-bottom: 10px;
            }
            &::v-deep .el-collapse-item__header {
                background-color: #f5f7fa;
                color: #313131;
            }
            .data-list-title {
                color: #313131;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                .title{
                    font-size: 14px;
                    font-weight: 500;
                    font-weight: bold;
                }
                .tip { 
                    font-size: 12px;
                    color: #FF4D4F;
                    padding-left: 8px;
                    cursor: pointer;
                }
            }
        }
        

        .dialog-header{
            height: 50px;
            line-height: 50px;
            border-bottom: solid 1px #dcdee2;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            text-indent: 20px;
            font-size: 14px;

            .close-btn{
                font-size: 18px;
                position: absolute;
                right: 25px;
                top: 15px;
            }
        }


    }

</style>
